import { useMutation } from "react-query";
import api from "../../../client";

const deleteData = async (id: string): Promise<{}> => {
  // TODO: response type
  const { data } = await api.delete<{}>(`/user/contact/${id}`);

  return data;
};

export const useDeleteUserContact = () => {
  return useMutation((id: string) => {
    return deleteData(id);
  });
};
